<div class="offresachat-bloc">
    <div class="tab-pane active in">
        <div class="content mesInfos-content  list-wrapper">
            <form *ngIf="!showSendMail" #shareFriendForm="ngForm" class="p-4" novalidate>
                <div class="list list-infos">
                    <div class="description-visites my-2">
                        <h3>Vous</h3>
                        <div class="infos-visites">
                            <div class="form-bloc">
                                <div class="row">
                                    <div class="input-wrapper col-sm-6">
                                        <div class="inner-form">
                                            <fieldset class="field-item field-text input-group">
                                                <input [(ngModel)]="formShareFriend.lastname" class="form-control"
                                                    type="text" name="prenom" aria-label="Prénom" placeholder="PRENOM *" id="last-name"
                                                    required>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div class="input-wrapper col-sm-6">
                                        <div class="inner-form">
                                            <fieldset class="field-item field-text input-group">
                                                <input [(ngModel)]="formShareFriend.email" class="form-control"
                                                    type="email" name="e-mail" aria-label="Votre e-mail" placeholder="E-MAIL *" id="validite-infos"
                                                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                                    required>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="description-visites my-2">
                        <div>
                            <h3>Vos amis</h3>
                        </div>
                        <div class="infos-visites">
                            <div class="form-bloc">
                                <div class="row">
                                    <div class="input-wrapper col-sm-6">
                                        <div class="inner-form">
                                            <fieldset class="field-item field-text input-group mb-3">
                                                <input [(ngModel)]="formShareFriend.email1" class="form-control"
                                                    type="email" name="e-mail1" aria-label="E-mail ami 1" placeholder="E-MAIL 1 *" id="e-mail1"
                                                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                                    [required]="formShareFriend.email2=='' && formShareFriend.email3== '' ">
                                            </fieldset>
                                            <fieldset class="field-item field-text input-group mb-3">
                                                <input [(ngModel)]="formShareFriend.email2" class="form-control"
                                                    type="email" name="e-mail2" aria-label="E-mail ami 2" placeholder="E-MAIL 2" id="apport-infos"
                                                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                                    [required]="formShareFriend.email1=='' && formShareFriend.email3== '' ">
                                            </fieldset>
                                            <fieldset class="field-item field-text input-group ">
                                                <input [(ngModel)]="formShareFriend.email3" class="form-control"
                                                    type="email" name="e-mail3" aria-label="E-mail ami 3" placeholder="E-MAIL 3"
                                                    id="credits-infos"
                                                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                                    [required]="formShareFriend.email1=='' && formShareFriend.email2== '' ">
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div class="input-wrapper col-sm-6">

                                        <div class="inner-form">
                                            <fieldset class="textarea-wrapper">
                                                <div class="inner-form clear">
                                                    <p class="input-wrapper">
                                                        <textarea [(ngModel)]="formShareFriend.message" name="message"
                                                            class="form-control" id="message-area" aria-label="Message" placeholder="MESSAGE"
                                                            cols="30" rows="4"></textarea>
                                                    </p>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="required-texte">* Champs obligatoires</p>
                    <div class="btn-action text-center">
                        <input class="btn btn-primary" type="submit" (click)="onSendShareFriend(bien)"
                            [disabled]="shareFriendForm.invalid || launchedRequest" value="Envoyer"
                            id="enregistrer-form-share">
                    </div>
                </div>
            </form>
            <app-app-message *ngIf="showSendMail"></app-app-message>
        </div>
    </div>
</div>

